import UseCase from "@domain/UseCase";
import { RemoveJobStore } from "@domain/stores/RemoveJobStore";

type Input = void;

type Output = void;

export class ClearRemoveJob implements UseCase<Input, Output> {
  constructor(private readonly removeJobStore: RemoveJobStore) {}

  execute() {
    return this.removeJobStore.clear();
  }
}
